import { AuthService } from './auth.service'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- lint-debt
export const handleAuthError = (authService: AuthService) => (error: any) => {
  if (error && error.statusCode === 401) {
    authService.signOut()
  }
}
